'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);

var ie11OnlyStyle = exports.ie11OnlyStyle = function ie11OnlyStyle(style) {
  return isIE11 ? style : undefined;
};